import { computed, Injectable, signal } from "@angular/core";
import { Tokens } from "./models";

export interface AuthStateModel {
  tokens?: Tokens;
}

@Injectable({ providedIn: 'root' })
export class AuthState {
  private static readonly state = signal<AuthStateModel>({});
  public static readonly accessToken = computed(() => AuthState.state().tokens?.accessToken);
  public static readonly refreshToken = computed(() => AuthState.state().tokens?.refreshToken);
  public static readonly idToken = computed(() => AuthState.state().tokens?.idToken);

  constructor() {
    const tokens = JSON.parse(localStorage.getItem('tokens') || 'null');
    if (tokens) {
      AuthState.setTokens(tokens);
    }
  }

  public static setTokens(tokens?: Tokens): void {
    this.state.set({ tokens });
    if (tokens) {
      localStorage.setItem('tokens', JSON.stringify(tokens));
    } else {
      localStorage.removeItem('tokens');
    }
  }
}

new AuthState();
